import { Arrow, ArrowSwap } from '@fs/zion-icon'
import { Button, IconButton, useOverlay } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import DemotePromoteUserDialogOverlay from '../dialogOverlays/DemotePromoteUserDialogOverlay'

export default function DemotePromoteUserButton({ memberSummaries, refreshUserGroupsDataAndControls, single }) {
  const overlay = useOverlay()
  const { t } = useTranslation()
  const promoting = memberSummaries[0].memberStatus === 'MEMBER'

  return (
    <>
      <DemotePromoteUserDialogOverlay
        memberSummaries={memberSummaries}
        refreshUserGroupsDataAndControls={refreshUserGroupsDataAndControls}
        {...overlay}
      />
      {single ? (
        <IconButton
          id="Demote/Promote User icon button"
          Icon={Arrow}
          onClick={overlay.handleClick}
          iconDirection={promoting ? 'up' : 'down'}
          color={promoting ? 'green' : 'red'}
        />
      ) : (
        <Button
          id="Demote/Promote User button"
          Icon={ArrowSwap}
          iconDirection="down"
          emphasis="high"
          onClick={overlay.handleClick}
        >
          {`${t('action.demote', 'Demote')}/${t('action.promote', 'Promote')}`}
        </Button>
      )}
    </>
  )
}
